/* A centre's Virtual Closet page (sections/vc-closet.liquid).

   Shop, Shop all and the product cards: ask the closet service for this
   tap's single-use 20% code, then go to the URL it returns (the store's
   discount link, landing with the `vc` parameter the theme keeps in its
   vc_closet cookie). The code this device already holds, from any centre, is
   passed as `prev`: an unused one for this centre is reused, and a spent one
   means this browser's 20% is used, so the service sends it to the store
   without a code (2026-10-16). If the request fails, the service's own shop
   link does the same job by redirect.

   Visits, Shop taps and Sponsor taps are counted by the closet service for
   the closet's funnel (see track() below).

   Sponsor: the chosen amount is a variant of the hidden "Sponsor a closet"
   product, added with the centre on the line (the ledger reads _Closet and
   _Kind; "For" is what the shopper sees), then on to checkout. */
(function () {
  var root = document.querySelector('[data-vc-closet]');
  if (!root) return;
  // No 10% email popup on a page that already gives 20% (see closet.js).
  document.documentElement.classList.add('vc-shopper');
  var slug = root.getAttribute('data-slug');

  // This browser already spent its 20% this programme year (the vc_closet
  // cookie, marked used by assets/closet.js or the closet service): say so
  // here, with regular prices, rather than in the cart (Jamie, 2026-10-16).
  function markUsed() {
    if (root.hasAttribute('data-vc-demo')) return;
    var m = document.cookie.match(/(?:^|;\s*)vc_closet=([^;]*)/);
    if (!m) return;
    var f = decodeURIComponent(m[1]).split('|');
    if (f[4] !== 'used') return;
    var now = new Date();
    var start = new Date(now.getMonth() >= 8 ? now.getFullYear() : now.getFullYear() - 1, 8, 1).getTime();
    if ((parseInt(f[2], 10) || 0) < start) return; // spent in an earlier programme year
    root.classList.add('is-used');
  }
  markUsed();
  var name = root.getAttribute('data-name');
  var service = (root.getAttribute('data-service') || '').replace(/\/$/, '');

  function heldCode() {
    var m = document.cookie.match(/(?:^|;\s*)vc_closet=([^;]*)/);
    if (!m) return '';
    var parts = decodeURIComponent(m[1]).split('|');
    return parts[1] || '';
  }

  // The sample closet: every button says what it would do on a real closet
  // instead of doing it (no code, no cart).
  var demo = root.hasAttribute('data-vc-demo');

  // The closet funnel (rubies-automations virtual-closet/lib/tracking.js):
  // where this visit came from, kept for the tab so a tap on Shop or Sponsor
  // carries it. A visit through the closet's own address (a QR, the short
  // link) was counted there and arrives with `vcv`; any other is counted here,
  // once a tab. Both tags then leave the address bar, so a link copied from it
  // and shared counts as where it was shared. Never on the sample closet.
  var params = new URLSearchParams(location.search);
  var src = params.get('src') || '';
  var SRC_KEY = 'vc_src_' + slug, SEEN_KEY = 'vc_seen_' + slug;
  var counted = params.has('vcv');
  try {
    if (src) sessionStorage.setItem(SRC_KEY, src); else src = sessionStorage.getItem(SRC_KEY) || '';
    if (sessionStorage.getItem(SEEN_KEY)) counted = true;
    sessionStorage.setItem(SEEN_KEY, '1');
  } catch (e) {}
  function track(e, extra) {
    if (demo || !service) return;
    var body = { e: e, src: src, ref: document.referrer || '' };
    for (var k in extra) body[k] = extra[k];
    var url = service + '/api/track/' + encodeURIComponent(slug);
    var data = JSON.stringify(body);
    try { if (navigator.sendBeacon && navigator.sendBeacon(url, new Blob([data], { type: 'text/plain' }))) return; } catch (err) {}
    try { fetch(url, { method: 'POST', body: data, keepalive: true, mode: 'no-cors', headers: { 'Content-Type': 'text/plain' } }).catch(function () {}); } catch (err) {}
  }
  if (!counted) track('view');
  if (params.has('src') || params.has('vcv')) {
    params.delete('src');
    params.delete('vcv');
    var rest = params.toString();
    try { history.replaceState(history.state, '', location.pathname + (rest ? '?' + rest : '') + location.hash); } catch (e) {}
  }
  var note = root.querySelector('[data-vc-demo-note]');
  var noteTimer = null;
  function explain(text) {
    if (!note) return;
    note.textContent = text;
    note.hidden = false;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () { note.hidden = true; }, 5000);
  }

  // "See the fine print" opens it. However it opens, from that link or its
  // own summary, the whole of it scrolls into view, or its top when it is
  // taller than the screen (Jamie, 2026-10-15).
  var fine = document.getElementById('fine-print');
  // What sits pinned over the top of the page: the sample closet's banner.
  function topCover() {
    var banner = root.querySelector('.vcCloset__demoBanner');
    return banner ? banner.getBoundingClientRect().height : 0;
  }
  function showFine() {
    var box = fine.getBoundingClientRect();
    var cover = topCover();
    var room = window.innerHeight - cover;
    if (box.top >= cover && box.bottom <= window.innerHeight) return;
    var y = box.height <= room - 32 ? box.bottom - window.innerHeight + 16 : box.top - cover - 16;
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, window.scrollY + y), behavior: still ? 'auto' : 'smooth' });
  }
  // "Sponsor our closet" (the hero button and the used-state line) glides to
  // the sponsor band the way the fine print does, instead of jumping
  // (Jamie, 2026-10-16).
  root.addEventListener('click', function (e) {
    if (!e.target.closest('a[href="#sponsor"]')) return;
    var band = document.getElementById('sponsor');
    if (!band) return;
    e.preventDefault();
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, window.scrollY + band.getBoundingClientRect().top - topCover() - 16), behavior: still ? 'auto' : 'smooth' });
  });

  if (fine) {
    fine.addEventListener('toggle', function () { if (fine.open) requestAnimationFrame(showFine); });
    root.addEventListener('click', function (e) {
      if (!e.target.closest('a[href="#fine-print"]')) return;
      e.preventDefault();
      if (fine.open) showFine(); else fine.open = true;
    });
  }

  root.addEventListener('click', function (e) {
    var el = e.target.closest('[data-vc-shop]');
    if (el && demo) { e.preventDefault(); explain(root.getAttribute('data-demo-shop')); return; }
    if (!el || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    if (el.classList.contains('is-loading') || el.classList.contains('is-going')) return;
    el.classList.add(el.classList.contains('vcp-btn') ? 'is-loading' : 'is-going');

    var to = el.getAttribute('data-to') || '/';
    var fallback = service + '/' + encodeURIComponent(slug) + '/shop?to=' + encodeURIComponent(to) + '&src=' + encodeURIComponent(src);
    var url = service + '/api/shop/' + encodeURIComponent(slug) + '?to=' + encodeURIComponent(to) + '&prev=' + encodeURIComponent(heldCode()) + '&src=' + encodeURIComponent(src);
    var ctrl = 'AbortController' in window ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 8000);
    fetch(url, ctrl ? { signal: ctrl.signal } : {})
      .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error(r.status)); })
      .then(function (j) {
        // Keep the closet on the store before leaving: the landing's ?vc=
        // can be lost (Shopify's theme preview drops it), and this page is on
        // the store, so it writes the same cookie assets/closet.js reads.
        if (j && j.code) {
          var fields = [slug, j.code, Date.now(), root.getAttribute('data-name') || '', j.used ? 'used' : ''];
          // A resource page (sections/vc-resource.liquid): the cart says 20% off, no quarter.
          if (root.getAttribute('data-kind') === 'resource') fields.push('resource');
          var value = fields.join('|');
          var domain = /(^|\.)rubyshines\.com$/i.test(location.hostname) ? '; Domain=.rubyshines.com' : '';
          // A spent 20% is kept until the programme year ends (September 1,
          // 04:00 UTC), an unused tap for the 30-day window, as assets/closet.js.
          var now = Date.now(), y = new Date(now).getUTCFullYear(), end = Date.UTC(y, 8, 1, 4);
          if (now >= end) end = Date.UTC(y + 1, 8, 1, 4);
          var maxAge = j.used ? Math.floor((end - now) / 1000) : 30 * 86400;
          document.cookie = 'vc_closet=' + encodeURIComponent(value) + domain + '; Path=/; SameSite=Lax; Max-Age=' + maxAge + (location.protocol === 'https:' ? '; Secure' : '');
          try {
            sessionStorage.removeItem('vc_closet_dismissed');
            // Tells assets/closet.js on landing that this code was just tapped
            sessionStorage.setItem('vc_closet_fresh', j.code);
          } catch (e) {}
        }
        window.location.href = (j && j.url) || fallback;
      })
      .catch(function () { window.location.href = fallback; })
      .finally(function () { clearTimeout(timer); });
  });

  // Back from the store, the browser restores this page as it was left,
  // spinner and all: reset the buttons whenever it is shown again.
  // Back from a purchase, the page is the one left before it: check the
  // cookie again so a 20% spent meanwhile shows as used (test 3, 2026-10-16).
  window.addEventListener('pageshow', function () {
    var busy = root.querySelectorAll('.is-loading, .is-going');
    for (var i = 0; i < busy.length; i++) busy[i].classList.remove('is-loading', 'is-going');
    markUsed();
  });

  var form = root.querySelector('[data-vc-sponsor]');
  if (!form) return;
  var amounts = Array.prototype.slice.call(form.querySelectorAll('[data-variant]'));

  function choose(btn) {
    amounts.forEach(function (b) { b.setAttribute('aria-checked', b === btn ? 'true' : 'false'); b.tabIndex = b === btn ? 0 : -1; });
  }
  var current = amounts.filter(function (b) { return b.getAttribute('aria-checked') === 'true'; })[0] || amounts[0];
  if (current) choose(current);

  amounts.forEach(function (b, i) {
    b.addEventListener('click', function () { choose(b); });
    b.addEventListener('keydown', function (e) {
      var step = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
      if (!step) return;
      e.preventDefault();
      var next = amounts[(i + step + amounts.length) % amounts.length];
      choose(next);
      next.focus();
    });
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (demo) { explain(root.getAttribute('data-demo-sponsor')); return; }
    var chosen = amounts.filter(function (b) { return b.getAttribute('aria-checked') === 'true'; })[0];
    if (!chosen) return;
    var submit = form.querySelector('[type="submit"]');
    // One press is one sponsorship: /cart/add adds again on every press, so a
    // second tap while checkout loads made it 2 x $10 (order #34250).
    if (submit && submit.classList.contains('is-loading')) return;
    if (submit) submit.classList.add('is-loading');
    track('sponsor', { amount: (chosen.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 20) });
    var params = new URLSearchParams();
    params.set('id', chosen.getAttribute('data-variant'));
    params.set('quantity', '1');
    params.set('properties[For]', name + "'s Virtual Closet");
    params.set('properties[_Closet]', slug);
    params.set('properties[_Kind]', 'sponsor');
    params.set('return_to', '/checkout');
    window.location.href = '/cart/add?' + params.toString();
  });
})();
